.row {
	display: table;
	width: 100%;
	table-layout: fixed;
	border-bottom: 1px solid var(--border-primary);
	cursor: pointer;
	height: 72px;
	max-height: 72px;
	overflow: hidden;
	padding-top: 0;
}

.rowLoading {
	pointer-events: none;
}

/* 
 * It allows buttons and links on the table rows to not trigger 
 * the row hover 
 */
.row:hover:not(:has(a:hover, button:hover)) {
	background-color: var(--elevation-low);
}

.row td {
	height: 72px;
	max-height: 72px;
	padding: 16px 12px;
	vertical-align: middle;
}

.row td:first-child {
	padding-left: 8px;
}
